import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: props => props.default_text_font,
    },
    modalClose: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingBottom: '13px'
    },
    modalTitleClose: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: 15,
        '& h6': {
            margin: 0,
            fontFamily: "inherit",
            fontSize: 18,
            color: '#6d6d6d',
            fontWeight: 500,
        },
        '& button': {
            padding: 0
        }
    },
    closeButton: {
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
        padding: '5px !important'
    },
    modalTitle: {
        textAlign: 'center',
        lineHeight: 2,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        '& h6': {
            margin: 0,
            fontFamily: "inherit",
            fontSize: 18,
            color: '#6d6d6d',
            fontWeight: 500,
            padding: '10px 16px',
            lineHeight: 2
        }
    },
    modalTitleDebut: {
        textAlign: 'center',
        lineHeight: 2,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        '& h6': {
            margin: 0,
            fontFamily: "inherit",
            fontSize: 17,
            color: '#6d6d6d',
            fontWeight: 500,
            padding: '10px 16px',
            lineHeight: 2
        }
    },
    modalBody: {
        textAlign: 'center'
    },
    innerBody: {
        padding: '15px !important'
    },
    qrCode: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& canvas': {
            cursor: 'default',
            position: 'relative',
            width: '250px !important'
        }
    },
    qrBorder: {
        position: 'relative',
        padding: '10px',
        '&::before, &::after, > :first-child:before, > :first-child:after': {
            content: '" "',
            position: 'absolute',
            width: '40px',
            height: '40px',
            borderColor: props => props.viewer_button.button_color,
            borderStyle: 'solid'
        },
        '&::before': { top: 0, left:0, borderWidth: '3px 0 0 3px' },
        '&::after': { top: 0, right:0, borderWidth: '3px 3px 0 0' },
        '& > :first-child:before': { bottom: 0, right: 0, borderWidth: '0 3px 3px 0' },
        '& > :first-child:after': { bottom: 0, left: 0, borderWidth: '0 0 3px 3px' }
    },
    modalCopy: {
        color: '#6d6d6d',
        margin: 0,
        fontWeight: 500,
        padding: '10px 0'
    },
    modalCopyDebut: {
        color: '#6d6d6d',
        margin: 0,
        fontWeight: 500
    },
    promptBody: {
        position: 'relative',
    },
    promptTips: {
        position: 'relative'
    },
    promptRow: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '1em',
        '&:first-child': {
            // paddingTop: '1em'
        }
    },
    promptIcon: {
        paddingRight: 15,
        '& img': { maxWidth: '50px' }
    },
    promptCopy: {
        '& h5': {
            paddingBottom: 5,
            fontSize: 15,
            margin: 0,
            fontWeight: 600,
            color: '#6d6d6d'
        },
        '& p': {
            fontSize: 13,
            lineHeight: '16px',
            margin: 0,
            color: '#6d6d6d'
        }
    },
    promptCopyBig: {
        '& p': {
            fontSize: 15,
            lineHeight: 1.5,
            margin: 0,
            color: '#6d6d6d'
        }
    },
    modalFooter: {
        display: 'flex',
        // justifyContent: 'center',
        justifyContent: 'space-around',
        padding: '15px !important',
    },
    default_modal_button: {
        ...theme.default_button,
        fontFamily: 'inherit',
        textTransform: 'uppercase',
        justifyContent: 'center',
        width: '100%',
        background: props => props.viewer_button.button_color,
        color: props => props.viewer_button.button_text_color
    },
    button_container_modal: {
        width: '100%',   
    },
    input_root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    btn_from_modal: {
        ...theme.default_button,
        textTransform: 'uppercase',
        padding: '10px 15px 10px',
        justifyContent: 'center',
        width: '100%',
        background: props => props.viewer_button.button_color,
        color: props => props.viewer_button.button_text_color,
        fontFamily: props => props.default_text_font,
        margin: 'auto',
        opacity: 1
    },
    btn_disabled: {
        opacity: .5,
        pointerEvents: 'none'
    },
    loaderSpinner: {
        border: '2px solid #ffffff',
        borderTopColor: props => props.viewer_button.button_color,
        borderTop: '2px solid',
        borderRadius: '50%',
        width: 16,
        height: 16,
        animation: '$spin .6s linear infinite'
    },
    formContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row !important',
        justifyContent: 'space-between',
        '& input': {
            // color: '#737373',
            fontSize: '1rem',
            padding: '1rem',
        }
    },
    heightType: {
        width: '65% !important',
        margin: '0 !important',
    },
    heightValue: {
        width: '30%'
    },
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
    }
}));
